import { useEffect, useRef } from 'react';

import './styles/LoadMore.css';

// Paginación "cargar más" reutilizable para listados scopeados por offset (useInfiniteQuery).
// Muestra "N de T" y, mientras haya más, un centinela que auto-carga la siguiente página al
// entrar en viewport (scroll) + un botón explícito como respaldo (teclado / sin IO).
// El server-state (páginas acumuladas) vive en TanStack Query — vite/03 [RIGID]; este
// componente es sólo la UI de la afordancia.
export default function LoadMore({ shown, total, hasMore, loading, onMore, noun = 'resultados' }) {
    const sentinel = useRef(null);
    // ref al último onMore para no re-suscribir el observer en cada render (onMore suele ser inline).
    const onMoreRef = useRef(onMore);
    useEffect(() => { onMoreRef.current = onMore; }, [onMore]);

    useEffect(() => {
        if (!hasMore || loading) return undefined;
        const el = sentinel.current;
        if (!el || typeof IntersectionObserver === 'undefined') return undefined;
        const io = new IntersectionObserver((entries) => {
            if (entries.some((e) => e.isIntersecting)) onMoreRef.current?.();
        }, { rootMargin: '240px' });
        io.observe(el);
        return () => io.disconnect();
    }, [hasMore, loading, shown]);

    return (
        <div className="load-more">
            <span className="load-more__count">Mostrando {shown} de {total} {noun}</span>
            {hasMore && (
                <>
                    <button type="button" className="load-more__btn" onClick={() => onMore?.()} disabled={loading}>
                        {loading ? 'Cargando…' : 'Cargar más'}
                    </button>
                    <span ref={sentinel} className="load-more__sentinel" aria-hidden="true" />
                </>
            )}
        </div>
    );
}
